import BaseAPIService from './baseAPI';

// Voice Processing Types
export interface VoiceToTextRequest {
  file: File;
  language_code: string;
}

export interface VoiceToTextResponse {
  data: {
    text: string;
    confidence: number;
    language: string;
  };
  status: string;
  message: string;
}

export interface VoiceToPostRequest {
  file: File;
  language_code: string;
  topic: string;
}

export interface VoiceToPostResponse {
  data: {
    transcribed_text: string;
    generated_post: string;
    confidence: number;
  };
  status: string;
  message: string;
  saved_post_id?: string;
}

export interface TextToSpeechRequest {
  text: string;
  voice: string;
  language: string;
}

export interface TextToSpeechResponse {
  data: {
    audio_url: string;
    audio_path: string;
  };
  status: string;
  message: string;
}

class VoiceAPIService extends BaseAPIService {
  constructor() {
    super();
  }

  async voiceToText(request: VoiceToTextRequest): Promise<VoiceToTextResponse> {
    const formData = new FormData();
    formData.append('file', request.file);
    formData.append('language_code', request.language_code);

    return this.postFormData<VoiceToTextResponse>('/voice/voice-to-text', formData);
  }

  async voiceToPost(request: VoiceToPostRequest): Promise<VoiceToPostResponse> {
    const formData = new FormData();
    formData.append('file', request.file);
    formData.append('language_code', request.language_code);
    formData.append('topic', request.topic);

    return this.postFormData<VoiceToPostResponse>('/voice/voice-to-post', formData);
  }

  async textToSpeech(request: TextToSpeechRequest): Promise<TextToSpeechResponse> {
    return this.post<TextToSpeechResponse>('/voice/text-to-speech', request);
  }

  async getSupportedVoices(): Promise<{ data: Array<{ code: string; name: string; language: string }> }> {
    return this.get<{ data: Array<{ code: string; name: string; language: string }> }>('/voice/supported-voices');
  }

  async getSupportedLanguages(): Promise<{ data: Array<{ code: string; name: string }> }> {
    return this.get<{ data: Array<{ code: string; name: string }> }>('/voice/supported-languages');
  }
}

export const voiceAPI = new VoiceAPIService();
export default voiceAPI; 